import React from 'react';

import PropTypes from 'prop-types';

import { SummaryMain, SummaryItemMain, SummaryItemLabel } from './css';

const TrackerCard = ({
  title,
  hardwareList,
  rateplanTotal,
  additionalServicesTotal,
  addonsTotal,
  vehiclesTotal
}) => {
  return (
    <div style={{ minWidth: '33%' }}>
      <h4>{title}</h4>
      <SummaryMain>
        <SummaryItemMain>
          <SummaryItemLabel>Total number of rate plans</SummaryItemLabel>
          <span>{rateplanTotal}</span>
        </SummaryItemMain>
        {Object.keys(hardwareList).map(hardwareName => (
          <SummaryItemMain>
            <SummaryItemLabel>Total number of {hardwareName}</SummaryItemLabel>
            <span>{hardwareList[hardwareName]}</span>
          </SummaryItemMain>
        ))}
        {additionalServicesTotal && (
          <SummaryItemMain>
            <SummaryItemLabel>
              Total number of additional services
            </SummaryItemLabel>
            <span>{additionalServicesTotal}</span>
          </SummaryItemMain>
        )}
        <SummaryItemMain>
          <SummaryItemLabel>Total number of add-on`s</SummaryItemLabel>
          <span>{addonsTotal}</span>
        </SummaryItemMain>
        <SummaryItemMain>
          <SummaryItemLabel>Total number of vehicles</SummaryItemLabel>
          <span>{vehiclesTotal}</span>
        </SummaryItemMain>
      </SummaryMain>
    </div>
  );
};

TrackerCard.propTypes = {
  title: PropTypes.string.isRequired,
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  rateplanTotal: PropTypes.number.isRequired,
  additionalServicesTotal: PropTypes.number.isRequired,
  addonsTotal: PropTypes.number.isRequired,
  vehiclesTotal: PropTypes.number.isRequired
};

export default TrackerCard;
